<template>
    <div class="hello">
        <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-white shadow-sm py-3">
            <button
                class="navbar-toggler float-right"
                type="button"
                data-toggle="collapse"
                data-target="#navbarTogglerDemo03"
                aria-controls="navbarTogglerDemo03"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <img class="navbar-brand ml-5 logo-size" src="/images/logo.png" alt="Kovatek" />

            <div class="collapse navbar-collapse justify-content-between align-items-center" id="navbarTogglerDemo03">
                <ul class="navbar-nav mx-auto mt-lg-0">
                    <li class="nav-item mt-2">
                        <a-dropdown placement="bottomCenter">
                            <a class="ant-dropdown-link mx-3 kova-text" href="#">
                                <router-link to="/browse" class="kova-text"> Browse </router-link>
                            </a>
                        </a-dropdown>
                    </li>
                    <li class="nav-item mt-2">
                        <a-dropdown placement="bottomCenter">
                            <a class="ant-dropdown-link mx-3" href="#">
                                <router-link to="/projects" class="kova-text">
                                    My Jobs
                                </router-link>
                            </a>
                            <a-menu class="mt-3 px-3 bell-width" slot="overlay">
                                <a-menu-item class="kova-text font-weight-bolder mt-3 mx-3 modified-overlay" key="1">
                                    <div class="row">
                                        <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                                        <div class="col">
                                            <!-- <h6 class="kova-text text-left font-weight-bolder">Sun Yeoun W</h6> -->
                                            <p
                                                class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2"
                                            >
                                                <span class="kova-text">Sun Yeoun W</span> sent a proposal for <br />
                                                <span class="kova-text"> Project ID 457896</span>
                                            </p>
                                        </div>
                                    </div>
                                    <p class="text-right text-dark font-weight-bolder ctrl-size">
                                        <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago
                                    </p>
                                </a-menu-item>
                                <a-divider class="my-2 px-1" />
                                <a-menu-item class="kova-text font-weight-bolder mx-3 modified-overlay" key="2">
                                    <div class="row">
                                        <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                                        <div class="col">
                                            <!-- <h6 class="kova-text text-left font-weight-bolder">Sun Yeoun W</h6> -->
                                            <p
                                                class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-2"
                                            >
                                                <span class="kova-text">Sun Yeoun W</span> sent a proposal for <br />
                                                <span class="kova-text"> Project ID 457896</span>
                                            </p>
                                        </div>
                                    </div>
                                    <p class="text-right text-dark font-weight-bolder ctrl-size">
                                        <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago
                                    </p>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </li>
                    <li class="nav-item mt-2">
                        <router-link class="kova-text" to="/proposals">
                            <a class="mx-3 my-2 my-sm-0">Saved</a>
                        </router-link>
                    </li>
                    <!-- <li class="nav-item mt-2">    
        <a-dropdown placement="bottomCenter">
          <a class="ant-dropdown-link kova-text mx-3" href="#">
            <router-link class="kova-text" to="/chat">
                Messages
            </router-link>
          </a>
            <a-menu class="mt-3 px-3 bell-width" slot="overlay">
              <a-menu-item class="kova-text font-weight-bolder mt-3 mx-3 modified-overlay" key="1">
                <div class="row">
                  <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                  <div class="col">
                    <h6 class="kova-text text-left font-weight-bolder">Customise Wordpress login</h6>
                    <p class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1">Wordpress login, from username to username email and <br />phone number and make sure future updatable. </p>
                  </div>
                </div>
                <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
              
              </a-menu-item>
              <a-divider class="my-2 px-1"/>
              <a-menu-item class="kova-text font-weight-bolder mx-3 modified-overlay" key="2">
                <div class="row">
                  <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                  <div class="col">
                    <h6 class="kova-text text-left font-weight-bolder">Customise Wordpress login</h6>
                    <p class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1">Wordpress login, from username to username email and <br />phone number and make sure future updatable. </p>
                  </div>
                </div>
                <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
              </a-menu-item>
              <a-divider class="my-2 px-1"/>
              <a-menu-item class="kova-text font-weight-bolder mx-3 modified-overlay" key="3">
                <div class="row">
                  <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                  <div class="col">
                    <h6 class="kova-text text-left font-weight-bolder">Customise Wordpress login</h6>
                    <p class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1">Wordpress login, from username to username email and <br />phone number and make sure future updatable. </p>
                  </div>
                </div>
                <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
              </a-menu-item>
              <a-divider class="my-2 px-1"/>
              <a-menu-item class="kova-text font-weight-bolder mb-3 mx-3 modified-overlay" key="4">
                <div class="row">
                  <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                  <div class="col">
                    <h6 class="kova-text text-left font-weight-bolder">Customise Wordpress login</h6>
                    <p class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1">Wordpress login, from username to username email and <br />phone number and make sure future updatable. </p>
                  </div>
                </div>
                <p class="text-right text-dark font-weight-bolder ctrl-size"><font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes ago</p>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </li> -->
                </ul>
                <div class="flex-row justify-content-md-center justify-content-end">
                    <!-- <hr class="divider mt-2 mb-1 py-0"> -->
                    <ul class="navbar-nav mr-lg-4 pr-lg-4 mt-lg-0">
                        <li class="nav-item mt-2">
                            <a-dropdown placement="bottomCenter">
                                <a class="ant-dropdown-link kova-text mx-3" href="#"
                                    ><font-awesome-icon icon="bell"
                                /></a>
                                <a-menu class="mt-3 px-3 bell-width" slot="overlay">
                                    <a-menu-item
                                        class="kova-text font-weight-bolder mt-3 mx-3 modified-overlay"
                                        key="1"
                                    >
                                        <div class="row">
                                            <img
                                                src="../assets/kovatek/dev.png"
                                                alt=""
                                                class="rounded-circle img-height"
                                            />
                                            <div class="col">
                                                <h6 class="kova-text text-left font-weight-bolder">
                                                    Customise Wordpress login
                                                </h6>
                                                <p
                                                    class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1"
                                                >
                                                    Wordpress login, from username to username email and <br />phone
                                                    number and make sure future updatable.
                                                </p>
                                            </div>
                                        </div>
                                        <p class="text-right text-dark font-weight-bolder ctrl-size">
                                            <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes
                                            ago
                                        </p>
                                    </a-menu-item>
                                    <a-divider class="my-2 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder mx-3 modified-overlay" key="2">
                                        <div class="row">
                                            <img
                                                src="../assets/kovatek/dev.png"
                                                alt=""
                                                class="rounded-circle img-height"
                                            />
                                            <div class="col">
                                                <h6 class="kova-text text-left font-weight-bolder">
                                                    Customise Wordpress login
                                                </h6>
                                                <p
                                                    class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1"
                                                >
                                                    Wordpress login, from username to username email and <br />phone
                                                    number and make sure future updatable.
                                                </p>
                                            </div>
                                        </div>
                                        <p class="text-right text-dark font-weight-bolder ctrl-size">
                                            <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes
                                            ago
                                        </p>
                                    </a-menu-item>
                                    <a-divider class="my-2 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder mx-3 modified-overlay">
                                        <div class="row">
                                            <img
                                                src="../assets/kovatek/dev.png"
                                                alt=""
                                                class="rounded-circle img-height"
                                            />
                                            <div class="col">
                                                <h6 class="kova-text text-left font-weight-bolder">
                                                    Customise Wordpress login
                                                </h6>
                                                <p
                                                    class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1"
                                                >
                                                    Wordpress login, from username to username email and <br />phone
                                                    number and make sure future updatable.
                                                </p>
                                            </div>
                                        </div>
                                        <p class="text-right text-dark font-weight-bolder ctrl-size">
                                            <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes
                                            ago
                                        </p>
                                    </a-menu-item>
                                    <a-divider class="my-2 px-1" />
                                    <a-menu-item
                                        class="kova-text font-weight-bolder mb-3 mx-3 modified-overlay"
                                        key="4"
                                    >
                                        <div class="row">
                                            <img
                                                src="../assets/kovatek/dev.png"
                                                alt=""
                                                class="rounded-circle img-height"
                                            />
                                            <div class="col">
                                                <h6 class="kova-text text-left font-weight-bolder">
                                                    Customise Wordpress login
                                                </h6>
                                                <p
                                                    class="font-italic text-left text-dark font-weight-lighter mb-0 pb-0 ctrl-size-1"
                                                >
                                                    Wordpress login, from username to username email and <br />phone
                                                    number and make sure future updatable.
                                                </p>
                                            </div>
                                        </div>
                                        <p class="text-right text-dark font-weight-bolder ctrl-size">
                                            <font-awesome-icon class="kova-text ctrl-size" icon="clock" /> 30 minutes
                                            ago
                                        </p>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </li>
                        <li class="nav-item mt-2">
                            <a-dropdown placement="bottomCenter">
                                <a class="ant-dropdown-link kova-text adjust-icon" href="#">
                                    <router-link to="/profile">
                                        <img
                                            src="../assets/kovatek/asset-51.svg"
                                            alt=""
                                            class="rounded-circle"
                                            style="height: 25px"
                                        />
                                    </router-link>
                                </a>
                                <a-menu class="mt-3 px-4" slot="overlay">
                                    <a-menu-item class="kova-text font-weight-bolder modified-overlay mt-3" key="1">
                                        <router-link class="kova-text" to="/profile"> Profile </router-link>
                                    </a-menu-item>
                                    <a-divider class="my-3 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder modified-overlay" key="2"
                                        >Reports</a-menu-item
                                    >
                                    <a-divider class="my-3 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder modified-overlay" key="3">
                                        <router-link class="kova-text" to="/settings">Settings</router-link>
                                    </a-menu-item>
                                    <a-divider class="my-3 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder modified-overlay" key="3">
                                        <router-link class="kova-text" to="/settings?type=payments"
                                            >Payments & Billing</router-link
                                        >
                                    </a-menu-item>
                                    <a-divider class="my-3 px-1" />
                                    <a-menu-item class="kova-text font-weight-bolder modified-overlay mb-3" key="4"
                                        ><span @click="logoutHandler"> Log out </span></a-menu-item
                                    >
                                </a-menu>
                            </a-dropdown>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Navbar',
    props: {
        msg: String,
    },
    data() {
        return {
            collapsed: false,
            data: {},
        };
    },
    methods: {
        toggleCollapsed() {
            this.collapsed = !this.collapsed;
        },
        logoutHandler() {
            this.$store
                .dispatch('logout')
                .then(() => {
                    this.$router.push('/login');
                })
                .catch(err => {
                    this.error = err.response.data;
                });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-size {
    height: 35px;
    width: 125px;
}
.btn-outline-kovatek {
    border: solid 1px #20409a;
    transition: 0.25s;
}
.btn-outline-kovatek:hover {
    background-color: #20409a;
    color: #fff;
}

.btn-kovatek {
    background-color: #20409a;
    font-weight: bold;
    outline: 0;
    border: 0;
    width: 135px;
    height: 40px;
    color: #fff;
    border-radius: 30px;
    transition: 0.25s;
}
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}
.kova-text {
    color: #20409a;
    font-size: 16px;
    font-weight: bold;
}
.kova-text:hover {
    color: #06216d;
    /* #031547; */
}
.nav-link {
    font-size: 15px;
}
.adjust-icon {
    position: relative;
    bottom: 4px;
}
.img-height {
    height: 60px;
    width: 60px;
}
.ctrl-size {
    font-size: 12px;
}
.ctrl-size-1 {
    font-size: 14px;
}
.add-rounded {
    border-radius: 20px;
}
.ctrl-icon-size {
    font-size: 30px;
}
.icon-size {
    font-size: 24px;
    font-weight: bold;
    color: #000;
}
.browse-text {
    font-size: 20px;
}
.divider {
    display: none;
}
.modified-overlay:hover {
    background: transparent;
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .divider {
        display: block;
    }
}

@media screen and (max-width: 767px) {
    .divider {
        display: block;
    }
}
</style>
